import { ControlledDateOnlyPicker, ControlledTextField } from '@if/mui'
import { Alert, FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material'
import { usePostCreatePerson } from '@src/api/person-api'
import { usePersonResolver } from '@src/containers/Person/Person-schema'
import { PersonCreateDto, VALID_TEAMS } from '@src/types/Person'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import FormsDialog from '../Common/Dialog/FormsDialog'

interface PersonAddDialogProps {
  open: boolean
  onCloseAdd: () => void
}

const PersonAddDialog = ({ onCloseAdd, open }: PersonAddDialogProps) => {
  const { t } = useTranslation()
  const [createPerson, isCreating, error, isSuccess, isError] = usePostCreatePerson()
  const resolver = usePersonResolver()
  const {
    control,
    handleSubmit,
    reset: resetForm,
  } = useForm({
    resolver,
  })

  const onClose = () => {
    resetForm()
    onCloseAdd()
  }

  const onSubmit = handleSubmit((data) => {
    const person: PersonCreateDto = {
      email: data.email,
      fullName: data.fullName,
      startDate: data.startDate,
      endDate: data.endDate ? data.endDate : null,
      bambooId: data.bambooId,
      team: data.team,
    }
    void createPerson(person).then(() => {
      onCloseAdd()
      resetForm()
    })
  })

  return (
    <>
      <FormsDialog
        onCancel={onClose}
        onConfirm={onSubmit}
        title={t('common.refresh')}
        open={open}
        isPending={isCreating}
        isSuccess={isSuccess}
        isError={isError}
      >
        <Stack spacing={1} marginTop={1}>
          {error && <Alert severity="error">{error.message}</Alert>}
          <ControlledTextField control={control} name="fullName" label={t('person.fullName')} />
          <ControlledTextField control={control} name="email" label={t('person.email')} />
          <Stack direction="row" spacing={1}>
            <ControlledDateOnlyPicker control={control} name="startDate" label={t('person.startDate')} />
            <ControlledDateOnlyPicker control={control} label={t('person.endDate')} name="endDate" />
          </Stack>
          <ControlledTextField control={control} label={t('person.bambooId')} name="bambooId" />
          <FormControl fullWidth required>
            <InputLabel id="team-select-label-add">{t('person.team')}</InputLabel>
            <Controller
              name="team"
              control={control}
              defaultValue="Dev"
              render={({ field }) => (
                <Select {...field} labelId="team-select-label-add" label={t('person.team')} required>
                  {VALID_TEAMS.map((team) => (
                    <MenuItem key={team} value={team}>
                      {team}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
          </FormControl>
        </Stack>
      </FormsDialog>
    </>
  )
}

export default PersonAddDialog
